import { ProblemReportingTypes } from "../ActionTypes/ProblemReportingTypes";

let initialState = {
    ProblemReporting : [],
    ProblemReportingPagination : null

}

const ProblemReportingReducer = (state = initialState , action) => {

        switch(action.type){

            case ProblemReportingTypes.GET_PROBLEM_REPORTING :
                    let ProblemReporting_Copy = [];
                    ProblemReporting_Copy = [
                        ...state.ProblemReporting,
                        ...action.payload.data,
                    ];
                    state = {
                        ...state,
                        ProblemReportingPagination: action.payload,
                        ProblemReporting: ProblemReporting_Copy
                    };
                    break;

            case ProblemReportingTypes.CLEAR_PROBLEM_REPORTING :
                    state = {
                        ProblemReportingPagination: null,
                        ProblemReporting: []
                    };
                    break;
                }
        return state ;
}

export default ProblemReportingReducer;
